import { render, staticRenderFns } from "./user-picker.vue?vue&type=template&id=f9a673e6"
import script from "./user-picker.vue?vue&type=script&lang=ts"
export * from "./user-picker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports